/* import __COLOCATED_TEMPLATE__ from './sku.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { PayloadSku } from 'volta/models/search-entry';
import type SearchEntry from 'volta/models/search-entry';

interface BvAppSearchEntrySkuSignature {
  Args: {
    entry: SearchEntry<PayloadSku>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntrySkuComponent = templateOnlyComponent<BvAppSearchEntrySkuSignature>();

export default BvAppSearchEntrySkuComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Sku': typeof BvAppSearchEntrySkuComponent;
    'bv-app-search/entry/sku': typeof BvAppSearchEntrySkuComponent;
  }
}
